import type React from 'react'
import type { JSX, Ref } from 'react'
import type { BANNER_DESCRIPTION_WIDTH, MC_PADDINGS } from 'vars/index'
import type { MultiColumnsPadding } from './MultiColumns.h'
import type { IMultiColumnsItemProps } from './MultiColumnsItem'

import {
  MultiColumnsAlignItems,
  MultiColumnsJustifyContent,
  MultiColumnsRowGap,
} from './MultiColumns.h'
import { MultiColumnsStyled } from './MultiColumns.styled'

export interface IMultiColumnProps extends IMultiColumnsItemProps {
  ref?: Ref<HTMLDivElement>
  columnValue?: number
  paddings?: MultiColumnsPadding | MC_PADDINGS
  height?: number
  containerWidth?: BANNER_DESCRIPTION_WIDTH
  className?: string // https://github.com/callstack/linaria/blob/master/docs/BASICS.md#overriding-styles
  style?: React.CSSProperties
}

export function MultiColumns({
  ref,
  children,
  width = 100,
  height,
  alignItems = MultiColumnsAlignItems.FlexStart,
  justifyContent = MultiColumnsJustifyContent.FlexStart,
  columnGap,
  rowGap = MultiColumnsRowGap.INDENT_0,
  columnValue,
  paddings,
  containerWidth,
  className = '',
  style,
}: IMultiColumnProps): JSX.Element {
  return (
    <MultiColumnsStyled
      ref={ref}
      width={width}
      height={height}
      alignItems={alignItems}
      justifyContent={justifyContent}
      columnGap={columnGap}
      rowGap={rowGap}
      columnValue={columnValue}
      paddings={paddings}
      containerWidth={containerWidth}
      className={className}
      style={style}
    >
      {children}
    </MultiColumnsStyled>
  )
}
